import React, { useState } from 'react';
import { Table, Dropdown, ButtonGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';


export type ColumnConfig<T> = {
  label: string;
  accessor: keyof T | ((item: T) => React.ReactNode);
};

type GenericTableProps<T extends { id: string | number }> = {
  data: T[];
  columns: ColumnConfig<T>[];
  onView?: (item: T) => void;
  onEdit?: (item: T) => void;
  onCopy?: (item: T) => void;
  onDelete?: (item: T) => void;
};

export function GenericTable<T extends { id: string | number }>({
  data,
  columns,
  onView,
  onEdit,
  onCopy,
  onDelete,
}: GenericTableProps<T>) {
  const [selectedRow, setSelectedRow] = useState<number | null>(null);

  const handleRowClick = (index: number) => {
    setSelectedRow(index);
  };

  const { t } = useTranslation();

  return (
    <>
       <Table bordered hover responsive  className="table-striped align-middle table-borderless shadow-sm rounded">
      <thead className="table-light">
        <tr>
          {columns.map((col, idx) => (
            <th key={idx} className="text-nowrap">{col.label}</th>
          ))}
          {(onView || onEdit || onCopy || onDelete) && <th className="text-nowrap text-end">{t('operations')}</th>}
        </tr>
      </thead>
      <tbody>
        {data.map((item, rowIndex) => (
          <tr
            key={item.id}
            onClick={() => handleRowClick(rowIndex)}
            className={selectedRow === rowIndex ? 'table-primary' : ''}
            style={{ cursor: 'pointer' }}
          >
            {columns.map((col, colIndex) => (
              <td key={colIndex}>
                {typeof col.accessor === 'function'
                  ? col.accessor(item)
                  : (item as any)[col.accessor]}
              </td>
            ))}
            {(onView || onEdit || onCopy || onDelete) && (
              <td className="text-end" style={{ minWidth: "2.5rem"}}>
                <Dropdown as={ButtonGroup} align="end" style={{position: 'static'}}>
                  <Dropdown.Toggle variant="outline-secondary" size="sm" id={`dropdown-${item.id}`} className="d-flex align-items-center gap-1"
                  style={{ minWidth: "2.5rem" }}>
                  {t('select')}
                  
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="shadow" style={{zIndex: 1050, position: 'absolute', right: 0  }}>
                    {onView && <Dropdown.Item onClick={() => onView(item)}>{t('view')}</Dropdown.Item>}
                    {onEdit && <Dropdown.Item onClick={() => onEdit(item)}>{t('edit')}</Dropdown.Item>}
                    {onCopy && <Dropdown.Item onClick={() => onCopy(item)}>{t('copy')}</Dropdown.Item>}
                    {onDelete && (<Dropdown.Item onClick={() => onDelete(item)}>{t('delete')}</Dropdown.Item>)}
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </Table>
    </>
   
  );
}
